export default __webpack_public_path__ + "static/media/zoko-logo.59c5c28d.svg";